import { getURLBasedOnLocation } from '@/helpers/utils';

export const queryBanners = () =>
  fetch(`https://assets.${getURLBasedOnLocation()}/banners/state.json`)
    .then((response) => response.json())
    .then((data) => data);
